import {
  ADD_COMMENT,
  CAMPAIGN_PAGE_LOADED,
  CAMPAIGN_PAGE_UNLOADED,
  DELETE_COMMENT,
  UPLOAD_FREAK_IMAGE,
  UPLOAD_FREAK_VIDEO,
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case CAMPAIGN_PAGE_LOADED:
      return {
        ...state,
        campaign: action?.payload[0]?.campaign,
        comments: action?.payload[1]?.comments
      };
    case CAMPAIGN_PAGE_UNLOADED:
      return {};
    case ADD_COMMENT:
      return {
        ...state,
        commentErrors: action.error ? action.payload.errors : null,
        comments: action.error ?
          null :
          [action.payload.comment].concat(state.comments)
      };
    case DELETE_COMMENT:
      const commentId = action.commentId
      return {
        ...state,
        comments: state?.comments?.filter(comment => comment?.id !== commentId) || []
      };
    case UPLOAD_FREAK_IMAGE:
      return {
        ...state,
        imagesToUpload: action.payload ? action.payload.imagesToUpload : '',
        errors: action.error ? action.payload.errors : null
      };
    case UPLOAD_FREAK_VIDEO:
      return {
        ...state,
        videosToUpload: action.payload ? (state.videosToUpload || []).concat(action.payload.videosToUpload) : '',
        errors: action.error ? action.payload.errors : null
      };
    default:
      return state;
  }
};
